<script lang="ts" setup>
import { Icon } from '@brighterly/lib-lumee-ui'

import type { IconRef } from '@ts-icon/types'

defineOptions({
  name: 'LessonRoomControlButton',
})

withDefaults(defineProps<LessonRoomControlButtonProps>(), {
  label: '',
  enabled: false,
  disabled: false,
  danger: false,
  hasAlert: false,
  alert: false,
  wrapLabel: false,
})

const emit = defineEmits<{
  click: []
}>()

interface LessonRoomControlButtonProps {
  icon: IconRef
  label?: string
  enabled?: boolean
  disabled?: boolean
  danger?: boolean
  hasAlert?: boolean
  alert?: boolean
  wrapLabel?: boolean
}

</script>

<template>
  <button
    class="lesson-room-control-button"
    :class="{
      'lesson-room-control-button--enabled': enabled,
      'lesson-room-control-button--danger': danger && !enabled,
      'lesson-room-control-button--wrap-label': wrapLabel,
    }"
    type="button"
    :disabled="disabled"
    @click="emit('click')"
  >
    <span class="lesson-room-control-button__box">
      <Icon
        v-bind="icon"
        size="sm"
        color="inherit"
      />
      <span
        v-if="hasAlert"
        class="lesson-room-control-button__dot"
      />
      <span
        v-if="alert"
        class="lesson-room-control-button__dot lesson-room-control-button__dot--alert btly-text-label-m"
      >
        !
      </span>
    </span>
    <span
      v-if="label"
      class="lesson-room-control-button__label btly-text-body-s"
    >
      {{ label }}
    </span>
  </button>
</template>

<style scoped lang="scss" src="@scss/components/Atoms/LessonRoom/LessonRoomControlButton.scss" />
